// extracted by mini-css-extract-plugin
export default {"joinUsContainer":"JoinUs_joinUsContainer__JVlBh","joinTitle":"JoinUs_joinTitle__YyvGw","joinSubtitle":"JoinUs_joinSubtitle__Kqe-A"};